export default __webpack_public_path__ + "static/homepage-dff632a12e8584bef4c5e2d78ce34d3a.png";